module.exports = __webpack_public_path__ + "static/media/shelf-711.8f702a96.png";